import i18n from "i18next"
import 'moment/locale/es'
import 'moment/locale/zh-cn'
import 'moment/locale/de'
import 'moment/locale/hu'
import { initReactI18next } from "react-i18next"
import enTranslation from "./translations/en.json"
import huTranslation from "./translations/hu.json"
import deTranslation from "./translations/de.json"
import esTranslation from "./translations/es.json"
import zhTranslation from "./translations/zh.json"
import LanguageDetector from "i18next-browser-languagedetector"
import moment from 'moment'

const resources = {
  en: {
    translation: enTranslation
  },
  hu: {
    translation: huTranslation
  },
  de: {
    translation: deTranslation
  },
  es: {
    translation: esTranslation
  },
  zh: {
    translation: zhTranslation
  }
}

export function getMomentLocale(i18nLanguage: string): string {
  let momentLocale = i18nLanguage
  if (momentLocale === "zh") {
    momentLocale = "zh-cn"
  }
  return momentLocale
}

export const supportedLanguages = Object.keys(resources)

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['sessionStorage', 'navigator'],
      lookupCookie: undefined,
      caches: ['sessionStorage'],
      excludeCacheFor: ["cookies"]
    }
  })

moment.locale(getMomentLocale(i18n.language))

export default i18n
